import React, { ReactNode } from 'react'

import {
  BreadcrumbsProps,
  TBreadcrumbItem
} from 'components_new/molecules/Breadcrumbs'

import { useParams } from 'utils/hooks'
import { useReport } from 'redux/hooks/Reports'
import { useTranslation } from 'language/translator'

import ReportNavigation from 'components_new/organisms/ReportNavigation'

import PageLayout, { PageLayoutProps } from '../PageLayout'

interface ReportTemplateProps {
  children: ReactNode
  content?: Pick<
    NonNullable<PageLayoutProps['content']>,
    'editMode' | 'fullWidth'
  >
  rightSidebar?: Pick<
    NonNullable<PageLayoutProps['rightSidebar']>,
    'content' | 'size'
  >
  subpage?: TBreadcrumbItem
  topbar?: Pick<
    NonNullable<PageLayoutProps['topbar']>,
    'actions' | 'content' | 'options'
  >
  variant?: PageLayoutProps['variant']
}

const ReportTemplate = (props: ReportTemplateProps) => {
  const { children, content, rightSidebar, subpage, topbar, variant } = props

  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()

  const report = useReport(id)

  const breadcrumbs: BreadcrumbsProps['items'] = [
    {
      href: '/resources',
      icon: { name: 'Resources' },
      title: t('global', 'resources')
    },
    ...(report
      ? [
          {
            href: `/reports/${report.id}`,
            icon: { name: 'Reports' as const },
            title: report.title
          }
        ]
      : [])
  ]

  if (!report) return null // @TODO

  if (subpage) {
    breadcrumbs.push(subpage)
  }

  return (
    <>
      <PageLayout
        content={content}
        rightSidebar={{
          content: rightSidebar?.content,
          navigation: <ReportNavigation />,
          size: rightSidebar?.size ?? 'small'
        }}
        topbar={{
          actions: topbar?.actions,
          breadcrumbs: breadcrumbs,
          content: topbar?.content,
          mobile: { goBack: true },
          options: topbar?.options
        }}
        variant={variant ?? 'feed'}
      >
        {children}
      </PageLayout>
    </>
  )
}

export default ReportTemplate
